export const getDefaultExamOrganization = (organizations, defaultHeadquarter) => {
  const index = organizations.findIndex((organization => organization.courseId === defaultHeadquarter));
  if (~index) return true;
  return false;
}